var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuLinks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30769 7.80003C6.2773 7.80003 3.8 10.1171 3.8 13C3.8 15.883 6.2773 18.2 9.30769 18.2C9.78908 18.2 10.2 17.8296 10.2 17.3479C10.2 16.8661 9.78908 16.4957 9.30769 16.4957C7.24007 16.4957 5.58462 14.9195 5.58462 13C5.58462 11.0805 7.24007 9.50438 9.30769 9.50438C9.78908 9.50438 10.2 9.13393 10.2 8.6522C10.2 8.17048 9.78908 7.80003 9.30769 7.80003ZM16.6923 7.80003C16.2109 7.80003 15.8 8.17048 15.8 8.6522C15.8 9.13393 16.2109 9.50438 16.6923 9.50438C18.7599 9.50438 20.4154 11.0805 20.4154 13C20.4154 14.9195 18.7599 16.4957 16.6923 16.4957C16.2109 16.4957 15.8 16.8661 15.8 17.3479C15.8 17.8296 16.2109 18.2 16.6923 18.2C19.7227 18.2 22.2 15.883 22.2 13C22.2 10.1171 19.7227 7.80003 16.6923 7.80003ZM9.30769 12.1479C8.8263 12.1479 8.41538 12.5183 8.41538 13C8.41538 13.4818 8.8263 13.8522 9.30769 13.8522H16.6923C17.1737 13.8522 17.5846 13.4818 17.5846 13C17.5846 12.5183 17.1737 12.1479 16.6923 12.1479H9.30769Z",
    fill: "currentColor",
    stroke: "#828D99",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLinks);
export default __webpack_public_path__ + "static/media/menu-links.806489f62d45cf9e16c3402295e13a44.svg";
export { ForwardRef as ReactComponent };